import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const TOKEN_KEY = "ghost_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      setToken(null);
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export const authLogin = (email, password) => client.post(`/auth/login`, { email, password }).then((r) => r.data);
export const authMe = () => client.get(`/auth/me`).then((r) => r.data);
export const listUsers = () => client.get(`/users`).then((r) => r.data);
export const createUser = (body) => client.post(`/users`, body).then((r) => r.data);
export const updateUser = (id, body) => client.put(`/users/${id}`, body).then((r) => r.data);
export const deleteUser = (id) => client.delete(`/users/${id}`).then((r) => r.data);
export const changePassword = (current_password, new_password) => client.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data);

export const list = (coll) => client.get(`/${coll}`).then((r) => r.data);
export const create = (coll, body) => client.post(`/${coll}`, body).then((r) => r.data);
export const update = (coll, id, body) => client.put(`/${coll}/${id}`, body).then((r) => r.data);
export const remove = (coll, id) => client.delete(`/${coll}/${id}`).then((r) => r.data);
export const getDashboard = () => client.get(`/dashboard`).then((r) => r.data);
export const checkConflicts = (body) => client.post(`/requisitions/check-conflicts`, body).then((r) => r.data);
export const sendRfq = (id, vendorIds) => client.post(`/requisitions/${id}/send-rfq`, { vendor_ids: vendorIds }).then((r) => r.data);
export const updateQuote = (id, vendorId, body) => client.put(`/requisitions/${id}/rfq/${vendorId}`, body).then((r) => r.data);
export const awardVendor = (id, vendorId) => client.post(`/requisitions/${id}/award/${vendorId}`).then((r) => r.data);
export const costEstimate = (body) => client.post(`/cost-estimate`, body).then((r) => r.data);
export const getDistance = (pickup, delivery) => client.post(`/distance`, { pickup, delivery }).then((r) => r.data);
export const geocode = (query) => client.post(`/geocode`, { query }).then((r) => r.data);
export const freightClass = (body) => client.post(`/freight-class`, body).then((r) => r.data);
export const dispatchJobs = () => client.get(`/dispatch/jobs`).then((r) => r.data);
export const dispatchDrivers = () => client.get(`/dispatch/drivers`).then((r) => r.data);
export const dispatchMatch = (body) => client.post(`/dispatch/match`, body).then((r) => r.data);

export const driverJobs = () => client.get(`/driver/jobs`).then((r) => r.data);
export const getDeliveries = () => client.get(`/deliveries`).then((r) => r.data);
export const notifyDelivery = (id) => client.post(`/requisitions/${id}/notify-delivery`).then((r) => r.data);
export const submitPod = (id, body) => client.post(`/requisitions/${id}/pod`, body).then((r) => r.data);

export const bolPublicUrl = (id, token) => `${API}/public/bol/${id}?token=${encodeURIComponent(token || "")}`;

export const exportUrl = (coll, fmt) => `${API}/export/${coll}.${fmt}?token=${encodeURIComponent(getToken() || "")}`;

export default client;
